import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/yerkir-next/src/app/[locale]/about-us/AboutClientWrapper.tsx");
